module.exports = __webpack_public_path__ + "img/icon-live-your-life.c78350c6.svg";